import React from 'react';
import { motion } from 'framer-motion';

interface ErrorMessageProps {
  error: string;
  accountIdentifier?: string;
}

/**
 * ErrorMessage Component
 *
 * Displays error messages with consistent styling and animations.
 *
 * @component
 * @example
 * ```tsx
 * <ErrorMessage error="Connection failed" accountIdentifier="myorg-myaccount" />
 * ```
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, accountIdentifier = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-md bg-red-50 border border-red-200 p-4"
      role="alert"
      aria-live="assertive"
    >
      <div className="flex">
        <div className="ml-3">
          <h4 className="text-sm font-medium text-red-800">
            {accountIdentifier !== '' ? `Error with ${accountIdentifier}` : 'Error'}
          </h4>
          <div className="mt-2 text-sm text-red-700 whitespace-pre-wrap">
            <p>{error}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
